<template>
  <b-modal
    v-model="_value"
    hide-footer
    dialog-class="like-users-modal"
    content-class="like-users-modal__content"
    header-class="like-users-modal__header"
    body-class="like-users-modal__body">
    <template #modal-header>
      <div
        class="like-users-modal__close-button">
        <b-icon-x-circle-fill
          style="cursor: pointer;"
          @click="_value = false" />
      </div>
      <div class="d-flex align-items-center mt-3">
        <MaterialIcon
          icon="thumb_up"
          class="mr-1 like-btn"
          style="font-size: 1rem;" />
        <span class="text--grey05">いいねした人</span>
      </div>
    </template>
    <div v-if="users.length > 0">
      <AppListItem
        v-for="user in users"
        :key="user.id"
        :avatar="user.avatar"
        :name="user.name"
        :group="user.department.name"
        :position="user.position" />
    </div>
    <p
      v-else
      style="font-size: 14px;">
      この活動にはまだいいねがありません
    </p>
  </b-modal>
</template>

<script>
import AppListItem from '@/components/parts/AppListItem.vue'
export default {
  components: {
    AppListItem,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    users: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss">
.like-users-modal {
  position: relative;
  
  &__header.modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  &__close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    color: $grey04;
  }
}
</style>